
























































import BaseComponent from '@/components/base-component.vue';
import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import Component from 'vue-class-component';
import * as service from '@/services/patients';
import { PacienteFiltroDTO } from '@/interfaces/patient';
import { Prop, Watch } from 'vue-property-decorator';
import UiAutocompleClientsSubsidiaries from '../UI/autocomplete-clients-subsidiaries.vue';
import UiDatePicker from '../UI/date-picker.vue';

@Component({
  components: {
    UiAutocompleClientsSubsidiaries,
    UiDatePicker
  },
  directives: {}
})
export default class PatientMergeSearch extends BaseComponent {  
  @Prop()
  patientOrigin: any;

  filter:any = {};
  
  items = [];
  pagination: PaginationSyncDTO = new PaginationSyncDTO();
  pagina: ResultPagDTO<any> = new ResultPagDTO();
  loading = false;
  error = false;
  selected = null;
  

  public headers: any = [
    { text: '', value: '', sortable: false, width: '10px' },
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'Nascimento', value: 'nascimento', sortable: false },
    { text: 'Sexo', value: 'sexo', sortable: false },
    { text: 'Unidades', value: 'unidades', sortable: false },
  ];

  public onChangeFilter(): void {
    this.pagination.page = 1;
    this.pagination.rowsPerPageItems = [5];
    this.pagination.rowsPerPage = 5;
    this.search();
  }

  private search(): void {
    this.selected = null;
    this.items = [];
    this.loading = true;    
    let idUnidade =  this.filter.unidade ? this.filter.unidade.id : null;
    
    this.filter.oldTerm = this.filter.term;
    
    let parm = new PacienteFiltroDTO();
    parm.nome = this.filter.term;
    parm.idUnidade = idUnidade;
    parm.nascimento = this.filter.nascimento;
    parm.sexo = this.filter.sexo;
    parm.ativo = this.filter.ativo;
    parm.agrupado = this.filter.agrupado;
    parm.idNaoIncluir = this.patientOrigin.id;

    parm.update(this.pagination);
    service.listPatients(parm).subscribe(
      (result) => {
        this.items = result.content;
        this.loading = false;
        this.pagina = result;
        PaginationSyncDTO.update(this.pagination, result);
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }

  @Watch('selected')
  onSelectedChange() {
    this.$emit('input', this.selected);
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangePagination() {
    this.search();
  }
}
